"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleForceClientSideTextPrintable = exports.maybeUpdateProductOptions = exports.getBookInteriorPageCount = exports.updateProjectName = exports.updateProjectStatus = exports.update = exports.updatePrintableLayerUserData = exports.removeLayersFromPrintable = exports.removePrintablesFromPrintableGroup = exports.getProductOption = exports.findPrintableGroup = exports.updatePrintableGroupQuantityAction = exports.isPrintableRotatedInWorkspace = exports.getUsedGalleryImageIds = exports.getNumberOfFilledPrintables = exports.getMinMaxPagesForBookProject = exports.getMaxCopiesForPrintableGroup = exports.getUserPhotoLayers = exports.getEmptyUserPhotoLayers = exports.findPrintableInProject = exports.addInteriorPrintablesToBookProject = void 0;
var addInteriorPrintablesToBookProject_1 = require("./addInteriorPrintablesToBookProject");
Object.defineProperty(exports, "addInteriorPrintablesToBookProject", {
  enumerable: true,
  get: function () {
    return __importDefault(addInteriorPrintablesToBookProject_1).default;
  }
});
var findPrintableInProject_1 = require("./findPrintableInProject");
Object.defineProperty(exports, "findPrintableInProject", {
  enumerable: true,
  get: function () {
    return __importDefault(findPrintableInProject_1).default;
  }
});
var getEmptyUserPhotoLayers_1 = require("./getEmptyUserPhotoLayers");
Object.defineProperty(exports, "getEmptyUserPhotoLayers", {
  enumerable: true,
  get: function () {
    return getEmptyUserPhotoLayers_1.getEmptyUserPhotoLayers;
  }
});
var getUserPhotoLayers_1 = require("./getUserPhotoLayers");
Object.defineProperty(exports, "getUserPhotoLayers", {
  enumerable: true,
  get: function () {
    return getUserPhotoLayers_1.getUserPhotoLayers;
  }
});
var getMaxCopiesForPrintableGroup_1 = require("./getMaxCopiesForPrintableGroup");
Object.defineProperty(exports, "getMaxCopiesForPrintableGroup", {
  enumerable: true,
  get: function () {
    return __importDefault(getMaxCopiesForPrintableGroup_1).default;
  }
});
var getMinMaxPagesForBookProject_1 = require("./getMinMaxPagesForBookProject");
Object.defineProperty(exports, "getMinMaxPagesForBookProject", {
  enumerable: true,
  get: function () {
    return __importDefault(getMinMaxPagesForBookProject_1).default;
  }
});
var getNumberOfFilledPrintables_1 = require("./getNumberOfFilledPrintables");
Object.defineProperty(exports, "getNumberOfFilledPrintables", {
  enumerable: true,
  get: function () {
    return __importDefault(getNumberOfFilledPrintables_1).default;
  }
});
var getUsedGalleryImageIds_1 = require("./getUsedGalleryImageIds");
Object.defineProperty(exports, "getUsedGalleryImageIds", {
  enumerable: true,
  get: function () {
    return __importDefault(getUsedGalleryImageIds_1).default;
  }
});
var isPrintableRotatedInWorkspace_1 = require("./isPrintableRotatedInWorkspace");
Object.defineProperty(exports, "isPrintableRotatedInWorkspace", {
  enumerable: true,
  get: function () {
    return __importDefault(isPrintableRotatedInWorkspace_1).default;
  }
});
var updatePrintableGroupQuantityAction_1 = require("./updatePrintableGroupQuantityAction");
Object.defineProperty(exports, "updatePrintableGroupQuantityAction", {
  enumerable: true,
  get: function () {
    return __importDefault(updatePrintableGroupQuantityAction_1).default;
  }
});
var findPrintableGroup_1 = require("./findPrintableGroup");
Object.defineProperty(exports, "findPrintableGroup", {
  enumerable: true,
  get: function () {
    return __importDefault(findPrintableGroup_1).default;
  }
});
var getProductOption_1 = require("./getProductOption");
Object.defineProperty(exports, "getProductOption", {
  enumerable: true,
  get: function () {
    return __importDefault(getProductOption_1).default;
  }
});
var removePrintablesFromPrintableGroup_1 = require("./removePrintablesFromPrintableGroup");
Object.defineProperty(exports, "removePrintablesFromPrintableGroup", {
  enumerable: true,
  get: function () {
    return __importDefault(removePrintablesFromPrintableGroup_1).default;
  }
});
var removeLayersFromPrintable_1 = require("./removeLayersFromPrintable");
Object.defineProperty(exports, "removeLayersFromPrintable", {
  enumerable: true,
  get: function () {
    return __importDefault(removeLayersFromPrintable_1).default;
  }
});
var updatePrintableLayerUserData_1 = require("./updatePrintableLayerUserData");
Object.defineProperty(exports, "updatePrintableLayerUserData", {
  enumerable: true,
  get: function () {
    return __importDefault(updatePrintableLayerUserData_1).default;
  }
});
var update_1 = require("./update");
Object.defineProperty(exports, "update", {
  enumerable: true,
  get: function () {
    return __importDefault(update_1).default;
  }
});
var updateProjectStatus_1 = require("./updateProjectStatus");
Object.defineProperty(exports, "updateProjectStatus", {
  enumerable: true,
  get: function () {
    return __importDefault(updateProjectStatus_1).default;
  }
});
var updateName_1 = require("./updateName");
Object.defineProperty(exports, "updateProjectName", {
  enumerable: true,
  get: function () {
    return __importDefault(updateName_1).default;
  }
});
var getBookInteriorPageCount_1 = require("./getBookInteriorPageCount");
Object.defineProperty(exports, "getBookInteriorPageCount", {
  enumerable: true,
  get: function () {
    return __importDefault(getBookInteriorPageCount_1).default;
  }
});
var maybeUpdateProductOptions_1 = require("./maybeUpdateProductOptions");
Object.defineProperty(exports, "maybeUpdateProductOptions", {
  enumerable: true,
  get: function () {
    return __importDefault(maybeUpdateProductOptions_1).default;
  }
});
var toggleForceClientSideTextPrintable_1 = require("./toggleForceClientSideTextPrintable");
Object.defineProperty(exports, "toggleForceClientSideTextPrintable", {
  enumerable: true,
  get: function () {
    return __importDefault(toggleForceClientSideTextPrintable_1).default;
  }
});